import { Outlet } from 'react-router';

import RecordingDrawer from '@/features/sessions/components/recording-drawer/recording-drawer';
import { MainLayout } from '@/layouts';

const AppRoot = () => {
  return (
    <MainLayout>
      <Outlet />
      <RecordingDrawer />
    </MainLayout>
  );
};

export default AppRoot;
